"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELEMENT_BACKGROUND_TYPE = void 0;
var ELEMENT_BACKGROUND_TYPE;
(function (ELEMENT_BACKGROUND_TYPE) {
    ELEMENT_BACKGROUND_TYPE["COLOR"] = "adstudio-background-color";
    ELEMENT_BACKGROUND_TYPE["IMAGE"] = "adstudio-background-image";
    ELEMENT_BACKGROUND_TYPE["GRADIENT"] = "adstudio-background-gradient";
    ELEMENT_BACKGROUND_TYPE["VIDEO"] = "adstudio-background-video";
})(ELEMENT_BACKGROUND_TYPE || (exports.ELEMENT_BACKGROUND_TYPE = ELEMENT_BACKGROUND_TYPE = {}));
